import React from 'react';
import { useRecoilValue } from 'recoil';
import { NavCategory } from '../../enums/NavCategory.enum';
import { NavCategoryContext } from '../../enums/NavCategoryContext.enum';
import { useNavCategories } from '../../hooks/actions/useNavCategories';
import { isMobileState } from '../../recoil/selectors';
import { HomeLanderDesktop } from './HomeLanderDesktop';
import { HomeLanderMobile } from './HomeLanderMobile';

export const HomeLander: React.FC = () => {
  const isMobile = useRecoilValue(isMobileState);
  useNavCategories({ context: NavCategoryContext.LandingPage, initializeCategory: NavCategory.Bestsellers });
  return isMobile ? <HomeLanderMobile /> : <HomeLanderDesktop />;
};

export default HomeLander;
